// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var ItemTypes = {
    CARD: "card",
};
export var UserActionTypes = {
    COMMUNICATION: "communication",
    EDIT: "edit",
    DELETE: "delete",
    PASSWORD: "password",
    MANUAL_VERIFICATION: "manual_verification",
    LOGS: "logs",
};
